import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { formatWeight } from "@redotech/redo-fulfillment-outbound-labels-common/util";

export function getOrderWeightCsvColumn(
  weightFormat: WeightFormat,
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: "Total weight",
    cell: (row: FulfillmentGroupData) =>
      formatWeight(
        { unit: WeightUnit.G, value: row.displayWeightGrams ?? 0 },
        weightFormat,
      ),
  };
}
